import { authFetch, BASE_BACKEND_URL } from '../auth'
import React, { useContext, useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import ReactFilter from '../components/inputs/ReactFilterList'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFilter,
  faDownload,
  faCalendar,
  faMagnifyingGlass,
  faCircleDown,
  faFileArrowDown,
  faDownLong
} from '@fortawesome/free-solid-svg-icons'
import Pagination from '../layout/Pagination'
import { effectiveLocationWithAllowedLocation } from '../helpers/utils'
import { TASK_TYPE_DIC, TASK_TYPES } from './constants/constants'
import DatePicker from 'react-multi-date-picker'
import PosTaskReport from './task_details/PosTaskReport'
import PosTaskEffectivityContext from './context/PosTaskEffectivityContext'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import dayjs from '../utils/dayjsConfig'
import LoadingTable from '../components/LoadingTable'

export default function PosTaskEffectivityView(props) {
  const {
    fetchDataStatus,
    clientsData,
    tasksData,
    pagination,
    setFilterQuery,
    setDateQuery,
    setSearchQuery,
    filterQuery,
    dateQuery,
    searchQuery,
    fetchClientsFromServer,
    fetchTasksFromServer,
    handlePaginationClick,
    title,
    setPagination,
    isLoading
  } = useContext(PosTaskEffectivityContext)
  const [searchInput, setSearchInput] = useState('')
  const [filters, setFilters] = useState(new Map())
  const [filtersDic, setFiltersDic] = useState({
    'Tipo de Tarea': 'task_type',
    Cliente: 'client_uid'
  })
  const [taskDataDic, setTaskDataDic] = useState({
    'Captura de inventario': 'inventory',
    Encuesta: 'survey',
    'Verificación de planimetría': 'planimetry',
    'Captura de precios propios y/o competencia': 'price_capture'
  })
  const [resetReactFilters, setResetReactFilters] = useState(false)
  const [allSelectedOptions, setAllSelectedOptions] = useState(null)
  const [reportTask, setReportTask] = useState([])
  const [answersSurvey, setAnswersTask] = useState([])
  const [imagesSurvey, setImagesTask] = useState([])
  const [reportTaskDownload, setReportTaskDownload] = useState([])
  const [selectedDates, setSelectedDates] = useState(null)

  const filtersDisabled = Boolean(fetchDataStatus.filters)

  const isObjectNotEmpty = (obj) => obj && Object.keys(obj).length > 0

  useEffect(() => {
    buildFiltersQuery()
  }, [allSelectedOptions])

  useEffect(() => {
    handleFilterData()
  }, [clientsData])

  const handleSearch = (e) => {
    setSearchInput(e.target.value)
  }

  const handleEnterSearch = (e) => {
    if (e.key === 'Enter') {
      buildSearchQuery()
    }
  }

  const getTimestampFromDateTime = (date) => {
    const d = new Date(date)
    return d.toLocaleString()
  }

  const handlePlanimetryFulfilment = (planimetryFulfilled, taskType) => {
    if (taskType != 'planimetry') return 'N/A'
    if (planimetryFulfilled) return 'Sí'
    return 'No'
  }

  const buildSearchQuery = () => {
    let queryParam = ''
    if (searchInput) {
      queryParam = `&q=${searchInput}`
    }
    setSearchQuery(queryParam)
    setPagination((prev) => ({ ...prev, current_page: 1 }))
  }

  const handleSelectionChange = (identifier, selectedOptions) => {
    const selectedOptionsArray = Array.from(selectedOptions)
    setAllSelectedOptions((prevOptions) => {
      const newOptions = new Map(prevOptions)
      newOptions.set(identifier, selectedOptionsArray)
      return newOptions
    })
  }

  const buildFiltersQuery = () => {
    let queryParam = ''
    let taskArray = []
    let clientArray = []
    if (allSelectedOptions) {
      for (const [key, value] of allSelectedOptions) {
        if (value.length != 0) {
          if (key == 'Tipo de Tarea') {
            value?.map((task) => {
              taskArray.push(taskDataDic[task])
            })
            queryParam += `&${filtersDic[key]}=${taskArray.join(',')}`
          } else if (key == 'Cliente') {
            value?.map((v) => {
              let clientInfo = clientsData.find((c) => c[0] == v)
              clientArray.push(clientInfo[1])
            })
            queryParam += `&${filtersDic[key]}=${clientArray.join(',')}`
          } else {
            queryParam += `&${filtersDic[key]}=${value.join(',')}`
          }
        }
      }
      setFilterQuery(queryParam)
      setPagination((prev) => ({ ...prev, current_page: 1 }))
    }
  }

  const handleFilterData = async () => {
    let availableFilters = [
      {
        key: 'Tipo de Tarea',
        value: [
          'Captura de inventario',
          'Verificación de planimetría',
          'Encuesta',
          'Captura de precios propios y/o competencia'
        ]
      },
      { key: 'Cliente', value: [] }
    ]

    availableFilters[1].value = (clientsData || []).filter((c) => c[1]).map((c) => c[0])
    setFilters(availableFilters)
  }

  const handleDateFilter = (datesObj) => {
    if (!datesObj || datesObj.length === 0) {
      setDateQuery(null)
      setPagination((prev) => ({ ...prev, current_page: 1 }))
      return
    }

    const formatedDates = datesObj.map((date) => dayjs.unix(date.unix))
    const startDate = dayjs.min(formatedDates)
    const endDate = dayjs.max(formatedDates)
    const queryParam = `&start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}`

    setDateQuery(queryParam)
    setPagination((prev) => ({ ...prev, current_page: 1 }))
  }

  const resetFilters = () => {
    setAllSelectedOptions(null)
    setFilterQuery(null)
    setDateQuery(null)
    setSelectedDates(null)
    setResetReactFilters(!resetReactFilters)
  }
  const fetchTaskData = async (taskId) => {
    authFetch(`${BASE_BACKEND_URL}/pos_task_activities/${taskId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        if (response.status === 404) {
          return {
            error: true,
            message: 'No se encontró la tarea'
          }
        }
        return response.json()
      })
      .then((data) => {
        if (data.error) {
        } else {
          setReportTask(data)
          setAnswersTask(data.details_survey)
          setImagesTask(data.planimetry_images)
          setReportTaskDownload(true)
        }
      })
      .catch((e) => console.log(e))
  }

  const handleDownloadClick = async (taskId) => {
    try {
      await fetchTaskData(taskId)
    } catch (error) {
      console.log('Error al obtener datos de la tarea:', error)
      setReportTaskDownload(false)
    }
  }

  useEffect(() => {
    setReportTaskDownload(false)
  }, [reportTask, reportTaskDownload])

  return (
    <>
      <div className="index-header detailed-container">
        <h2 className="mb-20 float-unset">{title}</h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <h4 className="text-sub-title">Filtrar tareas por:</h4>
          <div className="filters-search-container mb-10">
            <FontAwesomeIcon className="filter-icon mr-10" icon={faFilter} />
            <div className="filters-container">
              {Array.from(filters).map((filter, indx) => (
                <div key={`flr-${indx}`} className="mr-10">
                  <ReactFilter
                    className="mr-10"
                    title={filter.key}
                    identifier={filter.key}
                    options={filter.value}
                    resetWatcher={resetReactFilters}
                    onSelectionChange={handleSelectionChange}
                    disabled={filtersDisabled || !filter.value?.length}
                  />
                </div>
              ))}
              <DatePicker
                disabled={filtersDisabled}
                range
                rangeHover
                dateSeparator=" - "
                months={[
                  'Enero',
                  'Febrero',
                  'Marzo',
                  'Abril',
                  'Mayo',
                  'Junio',
                  'Julio',
                  'Agosto',
                  'Septiembre',
                  'Octubre',
                  'Noviembre',
                  'Diciembre'
                ]}
                weekDays={['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab']}
                format="DD MMM"
                weekStartDayIndex={1}
                highlightToday={false}
                numberOfMonths={2}
                maxDate={dayjs().local().endOf('day').toDate()}
                value={selectedDates}
                onChange={(dateObjects) => {
                  handleDateFilter(dateObjects)
                  setSelectedDates(dateObjects)
                }}
                plugins={[
                  <Toolbar
                    position="bottom"
                    names={{
                      deselect: 'Deseleccionar'
                    }}
                    sort={['deselect']}
                  />
                ]}
                render={(value, openCalendar) => {
                  return (
                    <div
                      key={`flr-date`}
                      className={`mr-10 ${filtersDisabled ? 'react-filter-disabled' : ''}`}
                    >
                      <div className="react-filter-box filter-input-width-datepicker">
                        <div
                          title="Rango de fechas"
                          onClick={!filtersDisabled ? openCalendar : undefined}
                          className="react-filter-box-clickable-zone"
                        >
                          <div className="react-filter-titles">
                            {value?.length > 0 && (
                              <>
                                {Array.isArray(value) ? (
                                  <div className="filter-title-overflow">{value.join(' - ')}</div>
                                ) : (
                                  <div className="filter-title-overflow">{value}</div>
                                )}
                                <FontAwesomeIcon style={{ color: 'ef823a' }} icon={faCalendar} />
                              </>
                            )}
                            {value?.length == 0 && (
                              <>
                                <div className="filter-title-overflow">RANGO DE FECHAS</div>
                                <FontAwesomeIcon
                                  style={{ color: filtersDisabled ? '#D5D5D5' : '#597fa9' }}
                                  icon={faCalendar}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }}
              />
            </div>
            <div className="search-input-containter">
              <input
                value={searchInput}
                onChange={handleSearch}
                onKeyDown={handleEnterSearch}
                className="round-search-input"
                style={{ fontSize: 12 }}
                placeholder="Buscar por actividad o descripción"
              />
              {searchInput === '' && (
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="search-icon"
                  style={{ marginTop: -1 }}
                />
              )}
              {searchInput && (
                <div
                  title="Limpiar texto"
                  onClick={() => {
                    setSearchInput('')
                    setSearchQuery('')
                  }}
                  className="round-search-input-x"
                >
                  X
                </div>
              )}
            </div>
          </div>
          <div className="mb-20">
            {(filterQuery || dateQuery) && (
              <a onClick={resetFilters} className="reset-filter cursor-pointer mb-20">
                Restablecer filtros aplicados
              </a>
            )}
          </div>
          <div>
            <Table hover responsive>
              <thead className="table-header-gray">
                <tr>
                  <th className="vertical-align-middle" style={{ padding: '10px 25px' }}>
                    <span className="th-header-text">FECHA Y HORA</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text"># ACTIVIDAD</span>
                  </th>
                  <th sclassName="vertical-align-middle">
                    <span className="th-header-text">CLIENTE/ATRIBUTO(S)</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">TIPO DE TAREA</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">OBLIGATORIA</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">DESCRIPCIÓN</span>
                  </th>
                  <th className="vertical-align-middle">
                    <span className="th-header-text">CÓDIGO</span>
                  </th>
                  <th className="align-center-table-column">
                    <span className="th-header-text">CUMPLE PLANIMETRÍA</span>
                  </th>
                  <th className="align-center-table-column">
                    <span className="th-header-text">DENTRO DE GEOCERCA</span>
                  </th>
                  <th className="align-center-table-column">
                    <span className="th-header-text">DESCARGAR</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading && <LoadingTable text="Cargando..." headersCount={9} />}
                {!isLoading &&
                  tasksData?.map(
                    (task, indx) =>
                      ![TASK_TYPES.client_application.key, TASK_TYPES.expiration_date.key].includes(
                        task.task_type
                      ) && (
                        <tr key={indx}>
                          <td className="td-text-limited td-text-limited-space">
                            {getTimestampFromDateTime(task.created_date)}
                          </td>
                          <td className="td-text-limited">{task.uid}</td>
                          <td className="td-text-limited">
                            {task.client_uid} - {task.client_name}
                          </td>
                          <td className="td-text-limited">{TASK_TYPE_DIC[task.task_type]}</td>
                          <td className="td-text-limited">{task.is_mandatory_task ? 'SI' : 'NO'}</td>
                          <td className="td-text-limited">{task.task_description}</td>
                          <td className="td-text-limited">{task.task_uuid.slice(9, 18)}</td>
                          <td className="td-text-limited align-center-table-column">
                            {handlePlanimetryFulfilment(task.planimetry_fulfilled, task.task_type)}
                          </td>
                          <td className="td-text-limited align-center-table-column">
                            {effectiveLocationWithAllowedLocation(
                              task.effective_location,
                              task.has_allowed_location
                            )}
                          </td>
                          <td className="td-text-limited align-center-table-column">
                            <button
                              className="dropdown-btn-pos-activity"
                              type="button"
                              onClick={() => handleDownloadClick(task.uuid)}
                            >
                              <FontAwesomeIcon icon={faDownLong} />{' '}
                            </button>
                          </td>
                        </tr>
                      )
                  )}
                {!isLoading && tasksData?.length === 0 && (
                  <tr>
                    <td colSpan="9" className="td-text-limited td-text-limited-space">
                      No hay resultados
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {fetchDataStatus?.tasks && <span>Obteniendo datos...</span>}
            {pagination.total_pages > 1 && (
              <nav className="index-table" onClick={handlePaginationClick}>
                <Pagination
                  current_page={pagination.current_page}
                  total_pages={pagination.total_pages}
                />
              </nav>
            )}
          </div>
        </div>
      </div>
      {reportTaskDownload && isObjectNotEmpty(reportTask) && (
        <PosTaskReport
          data={reportTask}
          answer={answersSurvey}
          images={imagesSurvey}
          shouldDownload={reportTaskDownload}
          setShouldDownload={setReportTaskDownload}
        />
      )}
    </>
  )
}
